import { QuestionPlanBase } from "./base/root";
import { QuestionPlanEmail } from "./email/root";
import { QuestionPlanPreQuestions } from "./pre-questions/root";

import type { DayTripPlanI18nCategoriesAndManagerStore } from "../_store/categories";

type Props = {
	dayTripPlanI18nCategoriesAndManagerStore: Omit<
		DayTripPlanI18nCategoriesAndManagerStore,
		"categoryManagerStore" | "categoryStoreArray"
	>;
	hotelID: string;
	planID: string;
	hotelEmailAddress: string;
};

export const DayTripPlanI18nFormMain = ({
	dayTripPlanI18nCategoriesAndManagerStore,
	hotelID,
	planID,
	hotelEmailAddress,
}: Props) => {
	const { base, email, preQuestions } = dayTripPlanI18nCategoriesAndManagerStore;

	return (
		<>
			<QuestionPlanBase base={base} />
			<QuestionPlanPreQuestions preQuestions={preQuestions} />
			<QuestionPlanEmail email={email} hotelID={hotelID} planID={planID} hotelEmailAddress={hotelEmailAddress} />
		</>
	);
};

DayTripPlanI18nFormMain.displayName = "DayTripPlanI18nFormMain";
